// export const API_URL = 'https://dev-api-pc.concrete-today.com'
export const API_URL = 'https://localhost:7264/'
export const GOOGLE_MAP_API_KEY = 'AIzaSyDarpg8lcEx40Wu37gDXHaz6dTMyNFOXDc'
export const ENCRYPT_SECRET_KEY = '+IvCO]j/a2w(Key'